import { keepPreviousData } from '@tanstack/react-query';
import { AGGREGATE_NAMES, LOAN_REQUEST_RESOLVERS } from 'cpool-constants';
import { schemaLoanRequestResolver_GetSchufa } from 'cpool-tables/backend-resolvers';

import { getQueryOptions } from '~/queryUtils/getQueryOptions';
import { useAggregateQuery } from '~/queryUtils/useQuery';
import { useQueryPositionStore } from '~/store/queryPositionStore';
import { queryKeys } from '~/utils/queryKeys';

const getSchufaQueryParameters = ({
    applicantId,
    leadId,
    queryPosition,
}: {
    leadId?: string;
    applicantId?: string;
    queryPosition?: string | number;
}) => {
    return {
        aggregateName: AGGREGATE_NAMES.LOAN_REQUEST,
        resolverName: LOAN_REQUEST_RESOLVERS.getSchufa,
        schema: schemaLoanRequestResolver_GetSchufa,
        searchParams: { applicantId, id: leadId, position: queryPosition },
        tanstack: {
            enabled: !!applicantId && !!leadId,
            placeholderData: keepPreviousData,
        },
    };
};

export const getSchufaQueryOptions = ({
    applicantId,
    leadId,
    queryPosition,
}: {
    leadId?: string;
    applicantId?: string;
    queryPosition?: string;
}) => getQueryOptions(getSchufaQueryParameters({ applicantId, leadId, queryPosition }));

export const useSchufa = ({ applicantId, leadId }: { leadId?: string; applicantId?: string }) => {
    const queryKey = queryKeys.getSchufa(leadId ?? '', applicantId);
    const queryPosition = useQueryPositionStore((state) => state.positions[JSON.stringify(queryKey)]);
    const params = getSchufaQueryParameters({ applicantId, leadId, queryPosition });
    return useAggregateQuery({
        ...params,
        acl: { loanRequestId: leadId },
    });
};
